import { Exercise, Level, SessionSequenceEntry, WorkoutSettings } from '../../../entities';

export abstract class SequenceContentEntryBuilder {
    protected transitionDuration: number = 2;
    public abstract build(
      exercise: Exercise, alternativeExercise: Exercise,
      secondAlternativeExercise: Exercise, thirdAlternateExercise: Exercise,
      zone: number, quarter?: number, level?: Level,
      workoutSettings?: WorkoutSettings, exerciseFormatDescription?: string)
      : SessionSequenceEntry ;
}
